import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { calculateAge, isBirthdayToday } from "../../../utils/birthdayUtils";
import { ApiRefreshContext } from "../../ApiRefreshContext";
import Anniversarycard from "./Anniversarycard";

export default function Anniversarypopup() {
  const [show, setShow] = useState(false);
  const [age, setAge] = useState(null);
 const { refreshFlag } = useContext(ApiRefreshContext);
  // Get user from Redux and localStorage
  const users = useSelector((state) => state.UserProfile.profile);
  const user = JSON.parse(localStorage.getItem("userData"));
  const name = users?.name || user?.name || "User";

useEffect(() => {
  const dobString = users?.date_of_join || user?.date_of_join;
  if (!dobString) return;

  const dob = new Date(dobString);

  const todayKey = new Date().toISOString().split("T")[0];
  const alreadyShownDate = localStorage.getItem("AnniversaryShown");

  if (isBirthdayToday(dob) && alreadyShownDate !== todayKey) {
    const calculatedAge = calculateAge(dob);
    setAge(calculatedAge);
    setShow(true);

    // Store today's date
    localStorage.setItem("AnniversaryShown", todayKey);

    // Auto hide after 10 seconds
    const timer = setTimeout(() => setShow(false), 10000);

    return () => clearTimeout(timer);
  }
}, [users, user, refreshFlag]);
// Only depend on the sources

  if (!show) return null;

  return (
    <Anniversarycard
      name={name}
      age={age}
      onClose={() => setShow(false)}
      photoUrl={users?.image_url || user?.image_url}
      show={show}
    />
  );
}
